import { AccordionPerson } from 'front-office/view-models/release-id-card';
import { SubjectData } from 'shell/models/person';
import { UserProfile } from 'shell/hooks/use-user-profile/types';

export const transformPerson = (
  subjectData: SubjectData,
  userProfile?: UserProfile
): AccordionPerson => {
  const residenceArray = subjectData.residenza || [];

  const enrollData = subjectData?.datiIscrizione;

  let state = '';

  let resident = false;

  // state check for object
  if (residenceArray[0]?.indirizzo?.toponimo) {
    if (residenceArray[0]?.indirizzo?.comune?.codiceIstat === userProfile?.datiLogin?.codiceIstat) {
      state = 'Residente';
      resident = true;
    } else {
      state = `Residente a ${residenceArray[0]?.indirizzo?.comune?.nomeComune || ''}`;
      resident = false;
    }
  }

  if (subjectData?.generalita?.soggettoAIRE && subjectData?.generalita?.soggettoAIRE === 'S') {
    if (
      (residenceArray[0]?.localitaEstera?.indirizzoEstero ||
        residenceArray[0]?.localitaEstera?.consolato) &&
      enrollData?.datiIscrizioneComune?.comune?.codiceIstat !== '015146'
    ) {
      state = `Iscritto AIRE - ${enrollData?.datiIscrizioneComune?.comune?.nomeComune || ''}`;
      resident = false;
    } else {
      state = 'Iscritto AIRE';
      resident = true;
    }
  }

  if (
    subjectData?.datiCancellazione &&
    subjectData?.datiCancellazione?.descrizioneMotivoCancellazione
  ) {
    state = `${subjectData.datiCancellazione.descrizioneMotivoCancellazione}`;
  }

  return {
    fiscalCode: subjectData.generalita?.codiceFiscale?.codFiscale || '',
    name: subjectData.generalita?.nome || '',
    surname: subjectData.generalita?.cognome || '',
    withoutName: subjectData.generalita?.senzaNome === '1' ? true : false,
    withoutSurname: subjectData.generalita?.senzaCognome === '1' ? true : false,
    state,
    resident,
  };
};
